import { pagination } from 'instantsearch.js/es/widgets';
import { connectPagination } from 'instantsearch.js/es/connectors';
import { paginationClasses } from './common.js';

export function createPagination(
  containerSelector = '[data-pagination]',
  scrollToSelector = '[data-search-videos]',
) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    return null;
  }

  return pagination({
    container,
    padding: 2,
    showFirst: true,
    showLast: true,
    showPrevious: true,
    showNext: true,
    scrollTo: scrollToSelector,
    templates: {
      first: `
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
        </svg>
      `,
      previous: `
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/>
        </svg>
      `,
      next: `
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
        </svg>
      `,
      last: `
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
        </svg>
      `,
    },
    cssClasses: {
      root: paginationClasses.root.join(' '),
      list: paginationClasses.list.join(' '),
      item: paginationClasses.item.join(' '),
      link: paginationClasses.link.join(' '),
      selectedItem: paginationClasses.selectedItem.join(' '),
      disabledItem: paginationClasses.disabledItem.join(' '),
      firstPageItem: paginationClasses.firstPageItem.join(' '),
      previousPageItem: paginationClasses.previousPageItem.join(' '),
      pageItem: paginationClasses.pageItem.join(' '),
      nextPageItem: paginationClasses.nextPageItem.join(' '),
      lastPageItem: paginationClasses.lastPageItem.join(' '),
    },
  });
}

export function createPaginationVisibility(
  containerSelector = '[data-pagination]',
) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    return null;
  }

  container.classList.add('transition-opacity', 'duration-300');

  return connectPagination(({ nbPages }) => {
    if (nbPages <= 1) {
      container.classList.add('opacity-0', 'pointer-events-none');
    } else {
      container.classList.remove('opacity-0', 'pointer-events-none');
    }
  })();
}
